import { render } from "./BalToggle.vue?vue&type=template&id=646f1f4c&ts=true"
import script from "./BalToggle.vue?vue&type=script&lang=ts"
export * from "./BalToggle.vue?vue&type=script&lang=ts"

import "./BalToggle.vue?vue&type=style&index=0&id=646f1f4c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__